"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutgoingBatchesActionbar = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const ess_types_1 = require("../../ess-types");
const detail_action_button_1 = require("../../../../composite/action-button/detail/detail-action-button");
const detail_actionbar_button_1 = require("../../../../composite/detail/detail-actionbar-button");
const detail_context_1 = require("../../../../composite/detail/detail-context");
const batches_api_1 = require("./batches-api");
function OutgoingBatchesActionbar({ url }) {
    var _a, _b, _c, _d;
    const intl = (0, react_intl_1.useIntl)();
    const { source } = (0, react_1.useContext)(detail_context_1.DetailContext);
    const externalize = (0, react_1.useMemo)(() => (0, batches_api_1.externalizeFactory)(url), [url]);
    const internalize = (0, react_1.useMemo)(() => (0, batches_api_1.internalizeFactory)(url), [url]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        ((_a = source.data) === null || _a === void 0 ? void 0 : _a.state) === ess_types_1.OutgoingBatchState.PROCESSED &&
            !((_b = source.data) === null || _b === void 0 ? void 0 : _b.externalized) && (react_1.default.createElement(detail_action_button_1.DetailActionButton, { promptKey: "ESS_OUTGOING_BATCHES_EXTERNALIZE", apiCall: externalize, buttonLabel: intl.formatMessage({
                id: 'ESS_OUTGOING_BATCHES_TOOLBAR_BTN_EXTERNALIZE',
                defaultMessage: 'Externalizovat',
            }), buttonTooltip: intl.formatMessage({
                id: 'ESS_OUTGOING_BATCHES_TOOLBAR_TOOLTIP_EXTERNALIZE',
                defaultMessage: 'Otevře dialog s potvrzením',
            }), dialogTitle: intl.formatMessage({
                id: 'ESS_OUTGOING_BATCHES_EXTERNALIZE_DIALOG_TITLE',
                defaultMessage: 'Varování',
            }), dialogText: intl.formatMessage({
                id: 'ESS_OUTGOING_BATCHES_EXTERNALIZE_DIALOG_TEXT',
                defaultMessage: 'Skutečně chcete všechny události z dávky externalizovat ?',
            }), ButtonComponent: detail_actionbar_button_1.PrimaryDetailActionbarButton })),
        ((_c = source.data) === null || _c === void 0 ? void 0 : _c.state) === ess_types_1.OutgoingBatchState.PROCESSED &&
            ((_d = source.data) === null || _d === void 0 ? void 0 : _d.externalized) && (react_1.default.createElement(detail_action_button_1.DetailActionButton, { promptKey: "ESS_OUTGOING_BATCHES_INTERNALIZE", apiCall: internalize, buttonLabel: intl.formatMessage({
                id: 'ESS_OUTGOING_BATCHES_TOOLBAR_BTN_INTERNALIZE',
                defaultMessage: 'Internalizovat',
            }), buttonTooltip: intl.formatMessage({
                id: 'ESS_OUTGOING_BATCHES_TOOLBAR_TOOLTIP_INTERNALIZE',
                defaultMessage: 'Otevře dialog s potvrzením',
            }), dialogTitle: intl.formatMessage({
                id: 'ESS_OUTGOING_BATCHES_INTERNALIZE_DIALOG_TITLE',
                defaultMessage: 'Varování',
            }), dialogText: intl.formatMessage({
                id: 'ESS_OUTGOING_BATCHES_INTERNALIZE_DIALOG_TEXT',
                defaultMessage: 'Skutečně chcete všechny události z dávky internalizovat ?',
            }), ButtonComponent: detail_actionbar_button_1.PrimaryDetailActionbarButton }))));
}
exports.OutgoingBatchesActionbar = OutgoingBatchesActionbar;
//# sourceMappingURL=batches-detail-actionbar.js.map